import { Controller } from "@hotwired/stimulus";
import "./component.scss";

// The card has no behaviour — this file exists so the stylesheet ships.
// entrypoints/application.js globs `components/**/component.js` and throws on a
// module without a default export, so a style-only component still exports a
// stub controller (same as components/footer and components/content_link_card).
// A component.scss with no component.js beside it is silently never bundled.
export default class extends Controller {
  connect() {}
}
